import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { es } from './locales/es';
import { pt } from './locales/pt';
import { en } from './locales/en';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: es,
      pt: pt,
      en: en,
    },
    fallbackLng: 'pt',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    ns: ['common', 'home', 'profile'],
    defaultNS: 'common',
    fallbackNS: 'common',
    backend: {
      loadPath: '/src/locales/{{lng}}/{{ns}}.json',
    },
  })
  .then(() => {});

export default i18n;
